const QR_CONTENT_TYPE = {
    CUSTOM: 0,
    VARIABLE: 1
};

const SHOW_BORDER = {
    SHOW: 1,
    HIDE: 0
};

const RATIO = 100;

export { QR_CONTENT_TYPE, SHOW_BORDER, RATIO };
